import { useUser } from "./useUser.ts";
import { useWorkspace } from "./useWorkspace.ts";

export const useIsUserWorkspaceOwner = () => {
  const { workspace } = useWorkspace();
  const { user } = useUser();
  return user && user.uuid === workspace.users.find((u) => u.is_owner)?.uuid;
};
